import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Configurás',
  desc: 'Armás tu infraestructura de cobro en dólares en 48 horas.'
}, {
  num: '2',
  title: 'Operás',
  desc: 'Identificás y realizás micro-tareas usando los prompts de IA que te entregamos.'
}, {
  num: '3',
  title: 'Cobrás',
  desc: 'Retirás tus ganancias al valor real del mercado y recuperás tu tranquilidad.'
}];
export function HowItWorks() {
  return <section className="py-24 px-4 relative" data-id="element-63">
      <div className="max-w-5xl mx-auto" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-65">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-66">
            Cómo funciona en <span className="text-emerald-400" data-id="element-67">3 pasos</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-68">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-12 left-[15%] right-[15%] h-0.5 bg-gradient-to-r from-emerald-900 via-emerald-500/50 to-emerald-900 z-0" data-id="element-69" />

          {steps.map((step, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.2
        }} className="relative z-10 flex flex-col items-center text-center" data-id="element-70">
              <div className="w-24 h-24 rounded-full bg-[#0a0f1a] border-4 border-emerald-500 flex items-center justify-center text-4xl font-black text-emerald-400 mb-6 shadow-[0_0_30px_rgba(16,185,129,0.2)]" data-id="element-71">
                {step.num}
              </div>
              <h3 className="text-2xl font-bold text-white mb-3" data-id="element-72">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed max-w-xs" data-id="element-73">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}